module.exports = __webpack_public_path__ + "static/media/S16_W.ffe87496.png";